import React, { useState } from 'react';
import '../../../component-styles/RetainerModal.css';

export default function RetainerModal({ onClose, onSave, nextNumber }) {
  const [form, setForm] = useState({
    requestDate: '',
    dueDate: '',
    description: '',
    amount: '',
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' })); // clear error when typing
  };

  const validate = () => {
    let newErrors = {};

    if (!form.requestDate) newErrors.requestDate = 'Request date is required.';
    if (!form.dueDate) newErrors.dueDate = 'Due date is required.';
    if (!form.description.trim()) newErrors.description = 'Description is required.';
    if (!form.amount || Number(form.amount) <= 0)
      newErrors.amount = 'Amount must be greater than 0.';

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);

    const validation = validate();
    setErrors(validation);

    if (Object.keys(validation).length > 0) return;

    onSave(form);
  };

  return (
    <div className="retainer-overlay" onClick={onClose}>
      <div className="retainer-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="retainer-modal-head">
          <h3>Retainer Request</h3>
          <div className="retainer-number">{nextNumber}</div>
        </div>

        {/* Error Message */}
        {submitted && Object.keys(errors).length > 0 && (
          <div className="retainer-error-msg">
            Please fill in all required fields before saving.
          </div>
        )}

        <form className="retainer-form" onSubmit={handleSubmit}>
          {/* Floating Label Date Fields */}
          <div className="retainer-grid">
            <div className="retainer-field">
              <label>Request Date</label>
              <input
                type="date"
                name="requestDate"
                value={form.requestDate}
                onChange={handleChange}
                className={errors.requestDate ? 'input-error' : ''}
              />
            </div>

            <div className="retainer-field">
              <label>Due Date</label>
              <input
                type="date"
                name="dueDate"
                value={form.dueDate}
                onChange={handleChange}
                className={errors.dueDate ? 'input-error' : ''}
              />
            </div>
          </div>

          <textarea
            name="description"
            placeholder="Retainer Description"
            value={form.description}
            onChange={handleChange}
            className={errors.description ? 'input-error' : ''}
          />

          <input
            name="amount"
            placeholder="Retainer Amount"
            type="number"
            value={form.amount}
            onChange={handleChange}
            className={errors.amount ? 'input-error' : ''}
          />

          <div className="retainer-actions">
            <button type="button" className="retainer-cancel" onClick={onClose}>
              Cancel
            </button>

            <button type="submit" className="retainer-save">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
